module.exports = __webpack_public_path__ + "img/bjh-icon.902b950f.gif";